import React, { useEffect, useState } from "react";

const ErrorPage = () => {

    return (
        <div className="App">
            <div className="Main">
                404 error. Page not found
            </div>
        </div>
    );
}

export default ErrorPage;